import { useTranslation } from "react-i18next";
import {
  useLocation,
  useNavigate,
  useSearchParams,
  Navigate,
} from "react-router-dom";
import { useStateContext } from "contexts/auth-context";

import { Box, Typography } from "@mui/material";

import CustomizedTab from "components/Custom/CustomizedTab";
import CustomizedButton from "components/Custom/CustomizedButton";
import CustomizedBreadcrumbs from "components/Custom/CustomizedBreadcrumbs";
import QuotationTable from "components/Table/Sales/Quotation";

import { IBreadcrumbsAndMenu, ITab } from "../../../types/global";
import HeaderLayout from "components/UI/HeaderLayout";
import { useElementHeight } from "hooks/use-element-height";

const Quotation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const isFilter = searchParams.get("filter");
  const {
    state: { permissions },
  } = useStateContext();
  const [headerRef, headerHeight] = useElementHeight();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("sales.index"),
      to: "/sales",
    },
    {
      name: t("sales.quotation.index"),
    },
  ];

  const tabs: ITab[] = [
    {
      label: t("status.all"),
      path: `${pathname}`,
    },
    {
      label: t("status.draft"),
      path: `${pathname}?filter=draft`,
    },
    {
      label: t("status.wait_accept"),
      path: `${pathname}?filter=wait_accept`,
    },
    {
      label: t("status.accepted"),
      path: `${pathname}?filter=accepted`,
    },
    {
      label: t("status.finished"),
      path: `${pathname}?filter=finished`,
    },
    {
      label: t("status.not_accepted"),
      path: `${pathname}?filter=not_accepted`,
    },
    {
      label: t("status.cancelled"),
      path: `${pathname}?filter=cancelled`,
    },
  ];

  const currentTab = pathname + (isFilter ? `?filter=${isFilter}` : "");

  if (permissions && !permissions.quotation?.view) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <>
      <Box ref={headerRef}>
        <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
        <HeaderLayout noMaxWidth>
          <Typography variant="h5" marginY={"auto"}>
            {t("sales.quotation.index")}
          </Typography>
          {permissions?.quotation?.create && (
            <CustomizedButton
              title={`${t("button.create")}${t("sales.quotation.index")}`}
              variant="contained"
              onClick={() => navigate(`${pathname}/add`)}
              startAddIcon
            />
          )}
        </HeaderLayout>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <CustomizedTab tabs={tabs} currentTab={currentTab} divider table />
        </Box>
      </Box>
      <QuotationTable isFilter={isFilter} height={`calc(90vh - ${headerHeight + 85}px)`} />
    </>
  );
};

export default Quotation;
